import { Typography } from '@mui/material'
import Image from 'next/image'
import { FC } from 'react'
import GridContainer from '../../../shared/components/GridContainer'
import useBasePath from '../../../shared/hooks/useBasePath'

const asSeenInImages = [
  { src: 'as_seen_in_credit-karma.svg', alt: 'Credit Karma' },
  { src: 'as_seen_in_nerdwallet.svg', alt: 'NerdWallet' },
  { src: 'as_seen_in_us-news.svg', alt: 'US News and World Report' },
  { src: 'as_seen_in_fortune.svg', alt: 'Fortune' },
  { src: 'as_seen_in_bloomberg.svg', alt: 'Bloomberg' },
]

const SocialProof: FC = () => {
  const withBasePath = useBasePath()
  return (
    <section id="social-proof" data-testid="social-proof" className="w-full bg-ink-100">
      <GridContainer>
        <div className="flex flex-col gap-y-4 md:flex-row md:items-center py-8 col-span-full overflow-x-auto">
          <Typography variant="label" className="mr-10 whitespace-nowrap text-ink-600">
            As seen in
          </Typography>
          <div className="flex flex-row justify-around w-full">
            {asSeenInImages.map(({ src, alt }) => (
              <div key={alt} className="relative min-w-[121px] aspect-[3.8] mr-10">
                <Image src={withBasePath(src)} alt={alt} fill />
              </div>
            ))}
          </div>
        </div>
      </GridContainer>
    </section>
  )
}

export default SocialProof
